export default __webpack_public_path__ + "static/example-bcfc0e53136067524c9c90d4c25b5099.png";